// src/app/user-avatar/user-avatar.component.ts
import { Component, Input } from '@angular/core';
import { Utils } from 'app/shared/utils';

@Component({
  selector: 'lineuppro-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss']
})
export class UserAvatarComponent {
  @Input() photo: string | null = null;
  @Input() userName: string = 'Unknown User';
  @Input() displayUserName: boolean = true;

  getInitials(name: string): string {
    return Utils.getInitials(name);
  }
}
